import * as Actions from '../../../redux/actions'

import React, { Component } from 'react'
import { validate, validate_fields } from "../Common/RegExValidate"

import Banner from '../Common/Banner.jsx'
import DestinationContainer from "./DestinationContainer"
import Header from '../Header/Header'
import ItineraryMap from "../Common/Trip/ItineraryMap"
import Loader from 'react-loader-spinner'
import MemberActionsInitial from "../Common/MemberActions/MemberActionsInitial"
import MemberAreaContainer from "../SocialPage/MemberAreaContainer"
import PageNotFound from '../ErrorPage/PageNotFound'
import PrivateTripEstablishment from "../Common/Trip/PrivateTripEstablishment"
import Profile from '../Common/Profile/ProfileBar.jsx'
import { Redirect } from "react-router-dom"
import TimelineWizardContainer from "../Common/TimelineWizardContainer"
import TripComtainer from "../Common/Trip/TripContainer"
import { connect } from 'react-redux'
import { list_container_mode } from '../Common/RegExValidate'
import { member_area_router } from "../Common/RegExValidate"

class DestinationPage_ extends Component {
    /* update screen size */
    updateDimensions = () => {
        this.props.setScreenSize(window.screen.width, window.screen.height)
        this.props.setBodyClientSize(document.body.clientWidth, document.documentElement.scrollHeight)
        this.props.setAppMenu(document.body.clientWidth)
    }
    /* initial component */
    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.props.setPageYOffset(0)
        this.props.setSwitchContainer(member_area_router.destination)
        this.props.setAppMenuBookingButtonStatus(true)
        this.props.setTripDisplayMode(list_container_mode.timeline)
    }
    /* destory component */
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions)
        this.props.cleanSearchQueryDestination()
        this.props.clearFeatureFormat()
    }
    render() {
        const lang = this.props.lang
        const { preload, switch_container, destinaionListDisplayFormat, tripMode } = this.props
        return (
            validate(lang, validate_fields.languages) ?
                <div style={{
                    height: "auto",
                }}>
                    {preload ? <Loader
                        type="Rings"
                        color="#19BC9B"
                        className="se-pre-con"
                        height={150}
                        width={150}
                        style={{
                            backgroundColor: "#FFFFFF"
                        }} /> : ""}
                        
                    {switch_container === member_area_router.destination &&
                        <React.Fragment>

                            {tripMode === list_container_mode.schedule && <TripComtainer />}
                            {tripMode === list_container_mode.calendar && <TripComtainer />}

                            {tripMode === list_container_mode.map && <Header bg_color={"rgba(25,25,25, 1)"} text_color={"var(--mainWhite)"} header_height={"half"} />}
                            {tripMode === list_container_mode.map && <TimelineWizardContainer listDisplayFormat={list_container_mode.map} />}
                            {tripMode === list_container_mode.map && window.google !== undefined && <ItineraryMap />}

                            {tripMode === list_container_mode.timeline && <Header bg_color={"rgba(25,25,25, 1)"} text_color={"var(--mainWhite)"} />}
                            {tripMode === list_container_mode.timeline && <TimelineWizardContainer listDisplayFormat={destinaionListDisplayFormat} />}
                            {tripMode === list_container_mode.timeline && <DestinationContainer props={this.props} />}

                        </React.Fragment>
                    }
                    {switch_container === member_area_router.memberAreaTrip &&
                        <React.Fragment>
                            {tripMode === list_container_mode.map ?
                                <React.Fragment>
                                    <Header bg_color={"rgba(25,25,25, 1)"} text_color={"var(--mainWhite)"} header_height={"half"} />
                                    <TimelineWizardContainer listDisplayFormat={list_container_mode.map} />
                                    {window.google !== undefined && <ItineraryMap />}
                                </React.Fragment> :
                                (tripMode === list_container_mode.timeline ?
                                    <React.Fragment>
                                        <Header bg_color={"rgba(25,25,25, 1)"} text_color={"var(--mainWhite)"} />
                                        <TimelineWizardContainer listDisplayFormat={list_container_mode.timeline} />
                                        <PrivateTripEstablishment />
                                    </React.Fragment> :
                                    <TripComtainer />)}
                        </React.Fragment>}
                    {(switch_container === member_area_router.trips
                        || switch_container === member_area_router.bucketList
                        || switch_container === member_area_router.favorites
                        || switch_container === member_area_router.personalInfo
                        || switch_container === member_area_router.muvTribe)
                        &&
                        <React.Fragment>
                            <Header bg_color={"rgba(25,25,25, 1)"} text_color={"var(--mainWhite)"} />
                            <Banner />
                            <Profile />
                            <MemberAreaContainer />
                        </React.Fragment>}

                    <MemberActionsInitial />
                </div>
                :
                <Redirect to={"error"} component={PageNotFound} />
        )
    }
}


const mapStateToProps = state => {
    return {
        destinaionListDisplayFormat: state.Destination.destination.destinaionListDisplayFormat,
        preload: state.Setting.preload,
        switch_container: state.Member.switch_container,

        lang: state.Setting.lang,
        tripMode: state.Member.tripMode,
    }
}

const mapDispatchToProps = {
    setBodyClientSize: Actions.setBodyClientSize,

    setScreenSize: Actions.setScreenSize,
    setAppMenu: Actions.setAppMenu,
    setScreenVerticalIsTop: Actions.setScreenVerticalIsTop,
    setAppMenuBookingButtonStatus: Actions.setAppMenuBookingButtonStatus,

    setPageYOffset: Actions.setPageYOffset,
    cleanSearchQueryDestination: Actions.cleanSearchQueryDestination,
    setSwitchContainer: Actions.setSwitchContainer,
    setTripDisplayMode: Actions.setTripDisplayMode,
    clearFeatureFormat: Actions.clearFeatureFormat,

}

const DestinationPage = connect(mapStateToProps, mapDispatchToProps)(DestinationPage_)
export default DestinationPage
